module.exports = __webpack_public_path__ + "assets/img/img-empty.1b79355a.png";